"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Stamp() {
    // Attributes.
    this._drawLayer = null;
    this._paletteItem = null;
}
export default Stamp;
//module.exports = Stamp;
Stamp.prototype.constructor = Stamp;


//===================================================
//
// Public
//
//===================================================

Stamp.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._paletteItem = Common.assets.getJSON("config").palettePanel.pages[Common.assets.getJSON("config").palettePanel.tools.stamp[0]][0];


    // Listen to HUD controls.
    Common.game.scene.palettePanel.signals.onStampChanged.add(this._onStamp_Changed, this);
};


//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

Stamp.prototype.onDrawBegan = function (point) {
    var scaleFactor = Math.random();

    this._drawLayer.context.save();
    this._drawLayer.context.translate(point.x, point.y);
    //this._drawLayer.context.scale( 0.6 + 0.4 * scaleFactor, 0.6 + 0.4 * scaleFactor );
    //this._drawLayer.context.rotate( Math.PI * 2 * Math.random() );
    //this._drawLayer.context.drawImage( this._image, -this._image.width * 0.5, -this._image.height * 0.5 );
    var texture = Common.assets.getTexture(this._paletteItem);
    var frame = texture.frame;
    this._drawLayer.context.drawImage(
        texture.baseTexture.source,
        frame.x * Common.main.assetRes,
        frame.y * Common.main.assetRes,
        frame.width * Common.main.assetRes,
        frame.height * Common.main.assetRes,
        0.5 * -frame.width,
        0.5 * -frame.height,
        frame.width,
        frame.height);
    this._drawLayer.context.restore();

    this._drawLayer.onContext_Changed();


    // Sfx.
    Common.audio.playSound("sfx_tool_stamp_use_00");
};

Stamp.prototype.onDrawMoved = function (from, to) {
};

Stamp.prototype.onDrawEnded = function () {
};

Stamp.prototype._onStamp_Changed = function (selection) {
    this._paletteItem = selection;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    Stamp.prototype,
    "paletteItem",
    {
        get: function () {
            return this._paletteItem;
        }
    });